import { Link } from "react-router-dom";

function Home() {
  const cars = [
    {
      image: "swift.webp",
      name: "Swift",
      category: "Economy",
      rate_per_km: "12/Km",
      passengers: "4 + 1",
      luggage_carry: 3,
      minimum_running_perday: "250",
      air_condition: "Yes",
      gps_navigation: "Yes",
    },
    {
      image: "ertiga.avif",
      name: "Ertiga",
      category: "Standard",
      rate_per_km: "15/Km",
      passengers: "6 + 1",
      luggage_carry: 3,
      minimum_running_perday: "250",
      air_condition: "Yes",
      gps_navigation: "Yes",
    },
    {
      image: "innova.avif",
      name: "Innova Crysta",
      category: "Business",
      rate_per_km: "18/Km",
      passengers: "6 + 1 / 7 + 1",
      luggage_carry: 3,
      minimum_running_perday: "250",
      air_condition: "Yes",
      gps_navigation: "Yes",
    },
    {
      image: "innova-hycross.avif",
      name: "Innova Hycross",
      category: "Business",
      rate_per_km: "20/Km",
      passengers: "6 + 1 / 7 + 1",
      minimum_running_perday: "250",
      luggage_carry: 3,
      air_condition: "Yes",
      gps_navigation: "Yes",
    },
    {
      image: "traveller.webp",
      name: "Tempo Traveller",
      category: "Tempo Traveller",
      rate_per_km: "27/Km",
      passengers: "17 + 1",
      minimum_running_perday: "300",
      luggage_carry: 3,
      air_condition: "Yes",
      gps_navigation: "Yes",
    },
    {
      image: "urbania.png",
      name: "Urbania",
      category: "Urbania",
      rate_per_km: "35/Km",
      passengers: "17 + 1",
      minimum_running_perday: "300",
      luggage_carry: 3,
      air_condition: "Yes",
      gps_navigation: "Yes",
    },
  ];

  const tour = [
    {
      image: "1.jpg",
      name: "UJJAIN TO INDORE AIRPORT",
      cost: "₹1,600/-",
    },
    {
      image: "2.webp",
      name: "UJJAIN Darshan Tour",
      cost: "₹2,600/-",
    },
    {
      image: "3.webp",
      name: "UJJAIN OMKARESHWAR",
      cost: "₹3,600/-",
    },
    {
      image: "4.webp",
      name: "UJJAIN-MAHESHWAR",
      cost: "₹4,600/-",
    },
    {
      image: "5.webp",
      name: "UJJAIN-MANDU",
      cost: "₹4,600/-",
    },
    {
      image: "6.jpg",
      name: "UJJAIN-DEWAS",
      cost: "₹2,100/-",
    },
    {
      image: "7.webp",
      name: "UJJAIN-BHOPAL",
      cost: "₹4,600/-",
    },
    {
      image: "8.jpg",
      name: "UJJAIN-SANCHI",
      cost: "₹4,600/-",
    },
    {
      image: "9.webp",
      name: "UJJAIN-PANCHMANI",
      cost: "₹9,100/-",
    },
    {
      image: "10.webp",
      name: "UJJAIN-BORESHWAR MAHADEV",
      cost: "₹2,100/-",
    },
    {
      image: "11.jpg",
      name: "SPECIAL TOUR PACKAGE",
      cost: "Customize Price",
    },
    {
      image: "12.jpg",
      name: "UJJAIN-RAM GHAT",
      cost: "₹4,600/-",
    },
  ];

  return (
    <>
      <section className="bg-pink p-2">
        <p class="text-white text-center fw-semibold m-0">
          Taxi Service in Ujjain &nbsp; &mdash; &nbsp; Experience hassle-free
          travel in Ujjain
        </p>
      </section>

      <img
        src="/assets/images/banner/5.png"
        alt=""
        loading="lazy"
        class="w-100 object-fit-cover d-lg-block d-none"
        height="450"
      />

      <img
        src="/assets/images/banner/5.png"
        alt=""
        loading="lazy"
        class="w-100 object-fit-cover d-lg-none d-block"
        height="350"
      />

      <section>
        <div className="container py-7">
          <div className="row justify-content-center align-items-center">
            <div className="col-lg-7 col-12 text-center">
              <p className="mb-3 h3 lh-sm text-dark lead fw-light opacity-75">
                Your Ride, Our Responsibility
              </p>
              <h1 className="display-5 text-dark fw-semibold ls-sm lh-sm mt-2">
                Professional & Reliable <u>Taxi Services in Indore Ujjain</u>{" "}
                for Every Journey &mdash; 24/7 Cab Booking
              </h1>
              <p className="my-3 h3 lh-sm text-dark lead fw-light opacity-75">
                Welcome to <u>Traveel Bug</u>, Indore Ujjain’s{" "}
                <u>most trusted taxi service</u>. Our mission is simple — to
                make every journey safe, smooth, and affordable.
              </p>
              <div className="d-flex align-items-center justify-content-center mt-5">
                <Link
                  to="/"
                  className="btn btn-dark text-light w-auto px-5 rounded-pill"
                >
                  Request Callback
                </Link>
                <Link
                  to="/"
                  className="btn border-1 border-dark text-dark fw-normal w-auto ms-2 px-5 rounded-pill"
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-light pt-3 pb-8">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center pt-2">
            <div>
              <h2 className="fw-bold mb-0 text-dark mt-2">
                Let's Check Available{" "}
                <u className="text-primary">
                  <span className="text-dark">Taxi 🚖</span>
                </u>
              </h2>
              <p className="lead lh-1">
                From local sightseeing to everyday rides, we’re here to make{" "}
                <u>every journey smooth and stress-free.</u>
              </p>
            </div>
          </div>

          <div className="row g-2 mt-1">
            {cars.map((item, index) => (
              <div className="col-lg-3 col-md-6 col-12" key={index}>
                <div className="bg-white rounded-5 h-100">
                  <div className="row gx-3 py-4">
                    <div className="col-12 d-flex justify-content-center flex-column align-items-center position-relative">
                      <img
                        src={`/assets/images/cars/${item.image}`}
                        alt=""
                        className="bg-white"
                        height="150"
                      />
                    </div>
                    <div className="col-12 mt-2">
                      <div className="px-3">
                        <div className="d-flex flex-column">
                          <div className="d-flex justify-content-between align-items-center bg-light rounded-2 py-2 px-3">
                            <h3 className="mb-0 fs-4 lh-1 text-dark">
                              {item.category}
                            </h3>
                            <h3 className="mb-0 fs-6 lh-1 text-dark">
                              ₹{item.rate_per_km}
                            </h3>
                          </div>
                          <p className="d-flex flex-column lh-sm mt-3 mb-2">
                            <span className="text-secondary">
                              <i className="bi bi-people me-1"></i>{" "}
                              {item.passengers} Passengers
                            </span>
                            <span className="text-secondary">
                              <i className="bi bi-luggage-fill me-1"></i>{" "}
                              {item.luggage_carry} Luggage
                            </span>
                            <span className="text-secondary">
                              <i className="bi bi-car-front-fill me-1"></i> Min.
                              Running Per Day &mdash;{" "}
                              {item.minimum_running_perday} KM
                            </span>
                            <span className="text-secondary">
                              <i className="bi bi-snow me-1"></i> Air Condition
                              &mdash; {item.air_condition}
                            </span>
                            <span className="text-secondary">
                              <i className="bi bi-pin-map-fill me-1"></i> GPS
                              Navigation &mdash; {item.gps_navigation}
                            </span>
                          </p>
                          <div className="lh-1">
                            <span className="text-secondary fw-semibold">
                              4.5
                            </span>{" "}
                            <span className="align-text-top">
                              <i className="bi bi-star-fill text-warning fs-6"></i>
                              <i className="bi bi-star-fill text-warning fs-6"></i>
                              <i className="bi bi-star-fill text-warning fs-6"></i>
                              <i className="bi bi-star-fill text-warning fs-6"></i>
                              <i className="bi bi-star-fill text-warning fs-6"></i>
                            </span>
                            <span className="text-gray-500 ms-2">(13,245)</span>
                          </div>
                        </div>
                        <div className="col-12 d-flex justify-content-between mt-4">
                          <div>
                            <Link className="btn border-1 border-dark bg-white btn-sm text-dark fw-normal rounded-3">
                              <i className="bi bi-telephone-fill"></i>
                            </Link>
                            <Link className="btn bg-success btn-sm text-white fw-normal rounded-3 mx-1">
                              <i className="bi bi-whatsapp"></i>
                            </Link>
                          </div>
                          <Link className="btn bg-warning btn-sm px-7 text-white fw-normal rounded-3">
                            Book Now
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="col-lg-6 col-12">
              <div className="gradient-section-1 rounded-5 h-100 d-flex flex-column justify-content-center mt-lg-0 mt-5">
                <div className="row text-center">
                  <div className="col-md-12 px-lg-8 px-6 py-lg-4 py-6">
                    <div class="text-center mb-5 px-lg-8 px-3">
                      <span class="text-uppercase text-warning fw-semibold ls-md">
                        Best <u>Taxi Service in Indore Ujjain</u>
                      </span>
                      <h2 class="fw-normal ls-sm lh-sm mt-2">
                        Enjoy safe, clean, and comfortable rides with{" "}
                        <span class="fw-bold text-white">Travel Bug.</span>
                      </h2>
                    </div>

                    <div class="row g-2 justify-content-center">
                      <div class="col-md-6 col-sm-12">
                        <div class="card h-100 text-center bg-white rounded-5 shadow">
                          <div class="card-body">
                            <div class="icon-shape icon-lg bg-light text-primary rounded-circle mx-auto mb-3">
                              <i class="bi bi-car-front fs-2"></i>
                            </div>
                            <h5 class="fw-semibold text-dark">
                              Clean & Modern Cabs
                            </h5>
                            <p class="text-dark-50 small mb-0 lh-sm">
                              Experience neat, air-conditioned cars with regular
                              maintenance for a fresh and pleasant journey every
                              time.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <div class="card h-100 text-center bg-white rounded-5 shadow">
                          <div class="card-body">
                            <div class="icon-shape icon-lg bg-light text-primary rounded-circle mx-auto mb-3">
                              <i class="bi bi-clock-history fs-2"></i>
                            </div>
                            <h5 class="fw-semibold text-dark">
                              On-Time Pickups
                            </h5>
                            <p class="text-dark-50 small mb-0 lh-sm">
                              We value your time — our punctual chauffeurs
                              ensure you reach your destination without delay.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-7 gradient-section-2" id="why-traveel-bug">
        <div class="container">
          <div class="row">
            <div className="row text-center">
              <div className="col-md-12 px-lg-8">
                <span className="text-uppercase text-white fw-semibold ls-md">
                  Why We’re the Best Taxi Service in Indore Ujjain
                </span>
                <h2 className="h1 fw-normal ls-sm text-dark lh-1 mt-1">
                  Enjoy safe, clean, and comfortable rides with trained
                  chauffeurs, verified drivers, and 100% travel safety assurance
                  — only with <span class="text-dark fw-bold">Travel Bug.</span>
                </h2>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center">
            <div className="col-lg-8 col-12 mt-4">
              <div className="row g-2 justify-content-center align-items-center">
                <div className="col-lg-6 col-12">
                  <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
                    <div className="d-flex align-items-center">
                      <div class="icon-shape icon-xl bg-light-primary rounded-circle">
                        <i class="bi bi-people fs-3 text-primary"></i>
                      </div>
                      <div className="ms-3">
                        <h3 class="mb-0 text-dark lh-1 fs-4">
                          Trained & Verified Chauffeurs
                        </h3>
                        <span className="text-secondary">
                          Professional drivers you can trust
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
                    <div className="d-flex align-items-center">
                      <div class="icon-shape icon-xl bg-light-primary rounded-circle">
                        <i class="bi bi-shield-check fs-3 text-primary"></i>
                      </div>
                      <div className="ms-3">
                        <h3 class="mb-0 text-dark lh-1 fs-4">
                          Travel Safety Guarantee
                        </h3>
                        <span className="text-secondary">
                          Your safety is our top priority
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
                    <div className="d-flex align-items-center">
                      <div class="icon-shape icon-xl bg-light-primary rounded-circle">
                        <i class="bi bi-x-circle fs-3 text-primary"></i>
                      </div>
                      <div className="ms-3">
                        <h3 class="mb-0 text-dark lh-1 fs-4">
                          Zero Cancellation
                        </h3>
                        <span className="text-secondary">
                          Guaranteed ride once booked
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="pe-6 ps-2 py-2 rounded-pill bg-white">
                    <div className="d-flex align-items-center">
                      <div class="icon-shape icon-xl bg-light-primary rounded-circle">
                        <i class="bi bi-car-front fs-3 text-primary"></i>
                      </div>
                      <div className="ms-3">
                        <h3 class="mb-0 text-dark lh-1 fs-4">
                          Recent, Neat & Clean Cabs
                        </h3>
                        <span className="text-secondary">
                          Comfortable rides in spotless cars
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-8 bg-white" id="destinations">
        <div className="container">
          <div className="row pt-7">
            <div className="col-12">
              <span className="badge bg-dark-soft rounded-pill fs-5 px-4">
                Best <span className="fw-bold">Destinations</span>
              </span>
              <h2 class="fw-bold mb-0 text-dark mt-2">
                Tours we Provide You{" "}
                <u class="text-primary">
                  <span class="text-dark">in Indore Ujjain</span>
                </u>
              </h2>
              <p className="lead lh-1 mb-2">
                At Traveel Bug, we believe travel is more than just visiting
                places—it’s about creating moments and memories that last
                forever.
              </p>
            </div>

            <div className="row gx-2 gy-3 mt-0">
              {tour.map((item, index) => (
                <div className="col-lg-3 col-md-6 col-12" key={index}>
                  <div class="shadow rounded-4">
                    <a href="#">
                      <img
                        src={`assets/images/city/${item.image}`}
                        alt=""
                        class="object-fit-cover rounded-4 w-100"
                        height="200"
                      />
                    </a>
                    <div class="mt-4 d-flex flex-column gap-3 px-3">
                      <div className="row g-2 border border-light rounded-4">
                        <div className="col-4 border-end m-0 d-flex justify-content-center align-items-center py-1">
                          <div className="text-center">
                            <img
                              src="/assets/images/clean-car.png"
                              width="20"
                            />
                            <p className="m-0 fs-6 lh-1 pt-1">
                              Clear
                              <br />
                              Car
                            </p>
                          </div>
                        </div>
                        <div className="col-4 border-end m-0 d-flex justify-content-center align-items-center py-1">
                          <div className="text-center">
                            <img src="/assets/images/deal.png" width="20" />
                            <p className="m-0 fs-6 lh-1 pt-1">
                              Transparent
                              <br />
                              Billing
                            </p>
                          </div>
                        </div>
                        <div className="col-4 m-0 d-flex justify-content-center align-items-center py-1">
                          <div className="text-center">
                            <img src="/assets/images/billing.png" width="20" />
                            <p className="m-0 fs-6 lh-1 pt-1">
                              Reliable
                              <br />
                              Service
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-column">
                        <div className="mb-2">
                          <span class="badge text-light-emphasis bg-light-subtle px-3 border border-light-subtle rounded-pill">
                            Trending
                          </span>
                        </div>
                        <h3 class="mb-0 h5 lh-1">
                          <a href="#" class="text-dark text-truncate">
                            {item.name}
                          </a>
                        </h3>
                        <small class="text-secondary">
                          1.9K Bookings Till Now
                        </small>
                        <div class="lh-1">
                          <span class="text-secondary fw-semibold">4.5</span>{" "}
                          <span class="align-text-top">
                            <i class="bi bi-star-fill text-warning fs-6"></i>
                            <i class="bi bi-star-fill text-warning fs-6"></i>
                            <i class="bi bi-star-fill text-warning fs-6"></i>
                            <i class="bi bi-star-fill text-warning fs-6"></i>
                            <i class="bi bi-star-fill text-warning fs-6"></i>
                          </span>
                          <span class="text-gray-500 ms-2">(1,045)</span>
                        </div>
                      </div>
                      <div>
                        <span class="fw-semibold text-dark">{item.cost}</span>
                      </div>

                      <div className="d-flex justify-content-between col-12 mb-3 pb-1">
                        <div>
                          <Link className="btn border-1 border-dark bg-white btn-sm text-dark fw-normal rounded-3">
                            <i className="bi bi-telephone-fill"></i>
                          </Link>
                          <Link className="btn bg-success btn-sm text-white fw-normal rounded-3 mx-1">
                            <i className="bi bi-whatsapp"></i>
                          </Link>
                        </div>
                        <Link className="btn bg-warning btn-sm px-7 text-white fw-normal rounded-3">
                          Book Now
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section class="pb-lg-3" id="about-us">
        <div class="container">
          <div class="row align-items-center">
            <div class="col-lg-6 col-md-12 col-12">
              <div class="pe-lg-6">
                <h1 class="display-5 fw-bold text-dark mb-3 ls-sm lh-1">
                  Best{" "}
                  <u class="text-primary">
                    <span class="text-dark">Taxi Service in Indore Ujjain</span>
                  </u>
                  , Travel Bug – 24/7 Cab Booking
                </h1>
                <p class="mb-2 h4 lh-sm text-dark fw-normal opacity-75">
                  Welcome to <u>Travel Bug</u>, your trusted partner for{" "}
                  <u>Taxi Service in Indore Ujjain</u>. We take pride in
                  offering safe, reliable, and comfortable travel solutions for
                  locals, tourists, and pilgrims alike. Whether you’re here for
                  the divine <u>Mahakaleshwar Darshan or exploring Ujjain’s</u>{" "}
                  rich cultural heritage, Travel Bug ensures a smooth and
                  memorable journey every time.
                </p>
                <p class="mb-3 h4 lh-sm text-dark fw-normal text-decoration-underline">
                  Your journey matters to us.
                  <br />
                  Travel Bug — Your Ride, Our Responsibility.
                </p>
                <div class="mt-3">
                  <h4 class="mb-1 text-dark fw-semibold">
                    Why Choose Traveel Bug?
                  </h4>
                  <ol className="lh-sm">
                    <li>Professional and polite drivers</li>
                    <li>Clean, comfortable, and air-conditioned cars</li>
                    <li>Affordable rates with no hidden charges</li>
                    <li>Easy booking through call or WhatsApp</li>
                    <li>24/7 availability for local and outstation rides</li>
                  </ol>
                </div>
                <a class="btn btn-dark px-5 btn-md mt-1 mb-lg-0 mb-5">
                  Contact Us
                </a>
              </div>
            </div>
            <div class="col-lg-6 col-md-12 col-12">
              <img src="/assets/images/cars.png" class="w-100 rounded-5" />
            </div>
          </div>
        </div>
      </section>

      <section class="bg-image d-flex align-items-center mt-5">
        <div class="container">
          <div class="row ">
            <div className="col-lg-5 col-12">
              <div className="position-relative z-3">
                <div className="px-6 bg-white rounded-5 py-3">
                  <h2 className="fs-3 text-dark fw-medium ls-sm lh-1 mt-4 mb-1">
                    Ready to Plan Your <u>Indore Ujjain Trip</u>
                  </h2>
                  <p class="mb-3 fs-4 text-secondary fw-light lh-1">
                    Your dream holiday is just one step away!
                  </p>

                  <form class="g-1">
                    <div className="row">
                      <div class="col-9">
                        <div class="input-group mb-2 border rounded-pill">
                          <span class="input-group-text bg-transparent border-0 pe-0 pe-1 ps-md-3 ps-md-0">
                            <i class="bi bi-person"></i>
                          </span>
                          <input
                            type="search"
                            class="form-control rounded-pill border-0 ps-3 form-focus-none"
                            placeholder="Full Name"
                          />
                        </div>

                        <div class="input-group mb-2 border rounded-pill">
                          <span class="input-group-text bg-transparent border-0 pe-0 pe-1 ps-md-3 ps-md-0">
                            <i class="bi bi-telephone"></i>
                          </span>
                          <input
                            type="search"
                            class="form-control rounded-pill border-0 ps-3 form-focus-none"
                            placeholder="Mobile No (+91)"
                          />
                        </div>
                      </div>
                      <div className="col-3">
                        <img
                          src="/assets/images/plane.png"
                          width="100"
                          className="position-absolute"
                        />
                      </div>
                    </div>
                    <div className="">
                      <button
                        type="submit"
                        class="btn btn-primary rounded-pill fw-normal px-5"
                      >
                        Request Callback
                      </button>
                    </div>
                  </form>
                  <div className="mb-3">
                    <p class="mt-3 fs-5 text-secondary fw-light lh-1">
                      <i className="bi bi-headset me-1"></i>
                      Request a Travel Quote
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="pb-3" id="booking-process">
        <div className="container">
          <div className="row">
            <div className="offset-xl-1 col-xl-10 col-md-12 col-12">
              <div className="row text-center">
                <div className="col-md-12 px-lg-8 mb-4 mt-6">
                  <span className="text-uppercase text-primary fw-semibold ls-md">
                    Our Process
                  </span>
                  <h2 className="h1 fw-normal ls-sm text-dark lh-sm">
                    Book Your Taxi in{" "}
                    <span class="text-dark fw-bold">3 Easy Steps</span>
                  </h2>
                </div>
              </div>
              <div className="row gy-6">
                <div className="col-md-4 col-12">
                  <div className="text-center">
                    <div className="icon-shape icon-lg border border-primary border-2 fs-3 rounded-circle mb-4 process-line text-primary smooth-shadow-md">
                      1
                    </div>
                    <h3 className="text-dark">Enquire</h3>
                    <p className="mb-0 px-3 lh-sm">
                      Reach out via call, chat, or our web form to book your{" "}
                      <u>Taxi Service in Indore Ujjain</u> with Travel Bug.
                    </p>
                  </div>
                </div>

                <div className="col-md-4 col-12">
                  <div className="text-center">
                    <div className="icon-shape icon-lg border border-primary border-2 fs-3 rounded-circle mb-4 process-line text-primary smooth-shadow-md">
                      2
                    </div>
                    <h3 className="text-dark">Get Expert Help</h3>
                    <p className="mb-0 px-3 lh-sm">
                      Our travel experts guide you with the best{" "}
                      <u>Indore Ujjain taxi service</u> options and travel
                      plans, free of charge.
                    </p>
                  </div>
                </div>

                <div className="col-md-4 col-12">
                  <div className="text-center">
                    <div className="icon-shape icon-lg border border-primary border-2 fs-3 rounded-circle mb-4 text-primary smooth-shadow-md">
                      3
                    </div>
                    <h3 className="text-dark">Confirm & Ride</h3>
                    <p className="mb-0 px-3 lh-sm">
                      Finalize your booking and enjoy a smooth, reliable trip
                      with the <u>best taxi service in Indore Ujjain</u>.
                    </p>
                  </div>
                </div>

                <div className="col-12 text-center">
                  <div className="d-flex align-items-center justify-content-center mt-2">
                    <Link
                      to="/"
                      className="btn btn-dark w-auto px-5 rounded-pill"
                    >
                      Request Callback
                    </Link>
                    <Link
                      to="/"
                      className="btn border-1 border-dark text-dark fw-normal w-auto ms-2 px-5 rounded-pill"
                    >
                      Contact Us
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="pt-5 pb-2">
        <div class="container">
          <div class="bg-black py-7 rounded-5">
            <div class="row align-items-center my-2">
              <div class="col-lg-6 col-md-6 col-12">
                <div className="px-lg-8 py-lg-1 px-4">
                  <h2 class="text-white lh-1">
                    Explore Indore Ujjain with the <u>Best Taxi Service</u>
                  </h2>
                  <p className="lead ls-sm mb-3 lh-1">
                    Your trusted travel companion
                  </p>
                  <p class="text-white-50 fs-4 lh-sm">
                    Discover the spiritual and cultural beauty of Indore Ujjain
                    — home to the sacred Mahakaleshwar Temple, Kaal Bhairav
                    Temple, and the peaceful Shipra River. With{" "}
                    <u>Travel Bug</u>, you can explore every corner of the city
                    at your own pace, without worrying about directions or
                    parking.
                  </p>
                  <p className="fs-4 text-white mb-1">
                    Book your Indore Ujjain taxi service today and enjoy:
                  </p>
                  <ol className="text-light">
                    <li>
                      Comfortable rides for individuals, families, and groups
                    </li>
                    <li>Doorstep pickup and drop-off</li>
                    <li>Flexible hourly or full-day rental packages</li>
                    <li>Safe and punctual service, every time</li>
                  </ol>
                  <button class="btn btn-light mt-3 px-5">
                    <i className="bi bi-telephone-fill me-1"></i> Make a Call
                  </button>
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <div class="text-center d-none d-md-block">
                  <img src="/assets/images/7.png" alt="" height="300" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
